import Model from './Model';

export default class JobStatus extends Model {
  baseURL() {
    return '';
  }

  resource() {
    return 'job-statuses';
  }
}
